<!-- v1.5 - in use -->

<template>
  <div id="pdpTabs">
    <div v-if="tabs.length > 0" class="ctpx-tab-sec">
      <section class="ctpx-tab-nav">
        <div class="container-fluid">
          <div class="row">
            <div class="col">
              <ul class="tab-nav">
                <li
                  v-for="(tab, index) in tabs"
                  :key="tab.title"
                  @click="selectTab(index)"
                  class="tab-nav-link"
                  :class="{ active: index == selectedTabIndex }"
                >
                  <span>{{ tab.title }}</span>
                </li>
              </ul>
            </div>
            <!-- .col -->
          </div>
          <!-- .row -->
        </div>
        <!-- .container -->
      </section>
      <!-- .ctpx-tab-nav -->
      <!-- ========== Section ctpx-tab-sec ========== -->
      <Tab
        v-for="(tab, index) in tabs"
        :tab="tab"
        class="ctpx-tab"
        :key="tab.title"
        :isActive="index == selectedTabIndex"
      ></Tab>
    </div>
    <!-- .ctpx-tab-sec -->
  </div>
  <!-- pdpTabs -->
</template>

<script src="./ctrl-pdp-tabs.js"></script>
